import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';


@Injectable()
export class CategoriesService {
  constructor(private readonly apiService: ApiService) {
  }

  getAll() {
    return this.apiService.get(
      '/categories'
    )
      .pipe(
        map(
          (result: any) => result.data
        )
      );
  }

  create(category) {
    return this.apiService.upload(`/categories`, category);
  }

  update(id: string, category) {
    return this.apiService.upload(`/categories/${id}`, category);
  }

  get(id: string) {
    return this.apiService.get(`/categories/${id}`)
      .pipe(
        map(
          (result: any) => result.data
        )
      );
  }

  destroy(id: string) {
    return this.apiService.delete(`/categories/${id}`);
  }

  getCategoriesStatics(id: string) {
    return this.apiService.get(`/statistics/category/${id}`);
  }

}
